export default __webpack_public_path__ + "dist/media/Refused.7a3c93fc.svg";